<section class="row" *ngIf="editable || data.enable">
  <div class="col-md-12" *ngIf="editable">
    <app-index-controller [data]="data">
      <!-- <li>
        <div class="checkbox checkbox-purple">
          <input type="checkbox" class="styled" name="isImageFill" id="isImageFill" [checked]="data.isImageFill"
            (change)="data.isImageFill = $event.target.checked">
          <label for="isImageFill">填滿圖片</label>
        </div>
      </li> -->
      <li>
        <button type="button" class="btn btn-default m-0 mb-2" (click)="openImageUploadModal()">上傳背景圖</button>
      </li>
    </app-index-controller>
    <app-image-upload-modal (imagesChange)="onImagesChange($event)" #imageUploadModal></app-image-upload-modal>
  </div>

  <ng-container>
    <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel" tabindex="-1">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <picture>
            <source attr.srcset="{{data.mobileBanner[0] | transform:'comp'}}" media="(max-width: 768px)" *ngIf="data.mobileBanner && data.mobileBanner[0]"/>
            <img src="{{data.baners && data.baners[0] && (data.baners[0] | transform: 'comp') || '/assets/images/no-pic_banner.webp'}}" class="fit_cover" alt=""
            tmErrorDefaultImage="/assets/images/no-pic_banner.webp">
          </picture>
          <div class="carousel-caption d-md-block">
            <div class="caption-title" [tmWow]="data.wowSetting"><span [attr.contenteditable]="editable" [(tmContenteditableModel)]="data.title" (tmContenteditableModelChange)="keepConnection()" appEditableContentPlaceholder="國家文化記憶庫"></span></div>
            <div class="caption-cont" [tmWow]="data.wowSetting"><span [attr.contenteditable]="editable" [(tmContenteditableModel)]="data.subTitle" (tmContenteditableModelChange)="keepConnection()" appEditableContentPlaceholder="TAIWAN CULTURAL"></span></div>
            <div class="caption-cont2" [tmWow]="data.wowSetting"><span [attr.contenteditable]="editable" [(tmContenteditableModel)]="data.subTitle2" (tmContenteditableModelChange)="keepConnection()" appEditableContentPlaceholder="MEMORY BANK"></span></div>
            <div class="form-wrap">
              <div id="hero-inner">
                <form id="hero-form" method="post" action="" autocomplete="off" [class.disableClick]="editable">
                  <label for="searchKeyword" class="sr-only">{{'keyword' | translate}}</label>
                  <div class="search-c">
                    <label for="format" class="sr-only">{{'searchpage.dataFormat' | translate}}</label>
                    <select id="format" name="format" [(ngModel)]="format">
                      <option [ngValue]="undefined">{{'all' | translate}}</option>
                      <ng-container *ngFor="let opt of FORMAT_OPTIONS; index as i">
                        <ng-container *ngIf="opt.label !== '其他'">
                          <option [ngValue]="opt.value">{{opt.label}}</option>
                        </ng-container>
                      </ng-container>
                    </select>
                    <div class="selectbar" style="pointer-events: none; user-select: none;" aria-hidden="true"></div>
                  </div>
                  <input class="searchbar" type="text" id="searchKeyword" placeholder="{{'searchPlaceholder2' | translate}}"
                  name="searchKeyword" [(ngModel)]="searchKeyword" (ngModelChange)="onKeywordChange($event)"
                  (focus)="onFocusSearchKeywordInput()" #searchKeywordInput>
                  <tm-auto-complete-options #skACO="tmAutoCompleteOptions"
                  [options]="keywordsOptions"
                  [togglerEl]="searchKeywordInput"
                  id="exploreSearchKeywordOptions"
                  label="{{'keywordAutoCompleteOptions' | translate}}"
                  (selected)="searchKeyword = $event; onKeywordChange($event);"
                  ></tm-auto-complete-options>
                  <button type="submit" title="{{'search' | translate}}" (click)="onClickSearch($event)">
                    <i class="fa fa-search" aria-hidden="true"></i>
                    <span class="sr-only">{{'search' | translate}}</span>
                  </button>
                </form>
              </div>

              <ng-container *ngIf="remoteData.topKeywords?.length">
                <div class="tab-list" [tmWow]="data.wowSetting">
                  <div class="tab-list-title">{{'explorePage.everyoneFocusOn' | translate}} ｜</div>
                  <div class="note_out" [class.disableClick]="editable">
                    <ng-container *ngFor="let keyword of remoteData.topKeywords">
                      <div class="note">
                        <a routerLink="{{toHomePath}}/datasearch" [queryParams]="{keyword: keyword}" target="_blank" rel="noopener noreferrer"
                        title="{{keyword}}[{{'openNewWindow' | translate}}]" role="option"><span>{{keyword}}</span></a>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</section>